module.exports = __webpack_public_path__ + "static/media/image-3.b3222b82.png";